import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faPlus, faUserAlt } from '@fortawesome/free-solid-svg-icons'

const Header = ({ navClick }) => {
  const isAuthenticated = useSelector(store => store.session.isAuthenticated)

  return (
    <div className="flex items-center py-3 bg-green-500 pl-6 lg:pl-2 pr-6 space-x-4">
      <FontAwesomeIcon
        icon={faBars}
        id="navControl"
        className="lg:hidden cursor-pointer text-2xl text-white"
        onClick={navClick}
      />
      <h1 className="flex-grow font-bold text-gray-100 text-xl inline">
        <Link to="/">Wandering Labs :: Reserve</Link>
      </h1>

      <Link to={isAuthenticated ? '/settings' : '/sign-in'}>
        <FontAwesomeIcon icon={faUserAlt} className="text-2xl cursor-pointer text-green-200" />
      </Link>

      <Link to="/new">
        <FontAwesomeIcon icon={faPlus} className="text-2xl cursor-pointer text-green-200" />
      </Link>
    </div>
  )
}

export default Header
